// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCategoryByIdRequestModel from '../../model/get-category-by-id-request-model';
import GetCategoryByIdRequestDTO from '../dto/get-category-by-id-request-dto';
import dtoSchema from '../schemas/get-category-by-id-request-schema';

export default abstract class GetCategoryByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCategoryByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.translatedLanguage_ISO2 = data.translatedLanguage_ISO2;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  translatedLanguage_ISO2?: string;

  static toModel(dto: DeepPartial<GetCategoryByIdRequestDTO>): GetCategoryByIdRequestModel;
  static toModel(dto: DeepPartial<GetCategoryByIdRequestDTO> | undefined | null): GetCategoryByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCategoryByIdRequestDTO> | undefined | null): GetCategoryByIdRequestModel | undefined {
    return dto ? new GetCategoryByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCategoryByIdRequestModel> | GetCategoryByIdRequestModel): GetCategoryByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      translatedLanguage_ISO2: unwrapped.translatedLanguage_ISO2,
    } as GetCategoryByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCategoryByIdRequestModel, can not map to GetCategoryByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
